<template>
    <div class="mt-5 rounded border border-[#d1d5db] w-full max-w-7xl bg-white shadow">
        <div class="w-full Class Properties p-10">
            <div class="w-full h-[124px] bg-[#4361EE] rounded-lg text-center">
                <p class="pt-[15px] text-[#fff] text-[16px]">Available Points</p>
                <p class="text-[#fff] text-[48px]">{{ numberWithCommas(availableWalletAmount) }}</p>
            </div>
        </div>
        <div class="p-10 flex flex-col gap-2">
            <div class="font-inter-heading-15 text-content-basic-1 mb-2">Recipient Wallet</div>
            <div class="flex items-center gap-5">
                <DesignDropdownSelect
                    v-model="selectedWalletCategorySeq"
                    :options="walletCategoryOptions"
                    size="LG"
                    :width="'w-60'" 
                    placeholder="Select Wallet" 
                    :useDefaultMsg="false"
                    :error="showWalletCategoryError ? walletCategoryErrorMessage : null" 
                    @change="onChangeWalletCategory"/>
            </div>
        </div>
        <div class="w-full p-10">
            <div class="w-full h-[1px] bg-[#D9D9D9] relative">
                <div class="w-[160px] bg-[#fff] absolute text-center left-[50%] translate-x-[-50%] top-[-10px]">File Upload</div>
            </div>
        </div>
            <div class="flex justify-between items-center gap-5 flex-wrap p-5">
            <div class="flex justify-between items-center gap-5 grow">
                <a :href="require(`@/assets/file/transferSampleFile.xlsx`)" :download="isTransfer ? 'transferTemplateFile.xlsx' : 'deductTemplateFile.xlsx'">
                    <ElementsButton text="Download Template File" :fitContent="true" :height12="true" />
                </a>
                <form @submit="clickUploadButton" ref="fileUploadForm" class="flex grow">
                    <ElementsInput v-model="uploadFile" class="grow" inputName="multipartFile" inputtype="file" placeholder="Select File" :full="true" :acceptFileFormat="['.xlsx']" />
                    <ElementsButton class="ml-5" text="Upload" :fitContent="true" :height12="true" inputtype="submit" />
                </form>
                <ElementsButton text="Remove" :fitContent="true" :height12="true" :backgroundRed="true" @click-event="removeFile" />
            </div>
            <p v-if="inValidFileType" class="mt-1 font-caption-md-regular text-accent-red-3">
                {{ inValidFileTypeMessage }}
            </p>
        </div>

        <div class="w-full p-10 overflow-auto">
            <div class="min-w-full w-fit">
                <div class="w-full h-[1px] bg-[#D9D9D9] relative">
                    <div class="w-[147px] bg-[#fff] absolute text-center left-[50%] translate-x-[-50%] top-[-10px]">
                        <span v-if="isTransfer">Transfer</span>
                        <span v-if="isDeduct">Deduct</span> List
                    </div>
                </div>
                <div class="w-full">
                    <div class="text-[14px] text-center mt-[80px]" v-if="excelList.length == 0">+ Add employees to transfer points</div>
                </div>
                <div class="mt-[80px]" v-if="excelList.length != 0">
                    <template v-for="(employee, index) in excelList" v-bind:key="index">
                        <div class="flex justify-between items-center py-2.5 w-full" :class="{ 'bg-slate-50': index % 2 !== 0 }">
                            <div class="w-20 text-sm font-normal text-center truncate">
                                {{ index + 1 }}
                            </div>
                            <div class="text-base font-bold w-40 px-4 truncate">
                                {{ employee.employeeName }}
                            </div>
                            <div class="w-72 px-4 text-sm font-normal text-center truncate">
                                {{ $validateUtil.emptyValueToDash(employee.departmentName) }} / {{ $validateUtil.emptyValueToDash(employee.jobTitleName) }}
                            </div>
                            <div class="w-60 px-2 text-sm font-normal text-left "
                                :class="employee.isNotInteger || employee.emptyAmount ? 'mt-5':''">
                                <ElementsInput v-model="employee.mileageVolumeFormat" placeholder="0" :full="true" @input="onInputMileage($event, employee)"/>

                                <p v-if="employee.isNotInteger" class="text-sm text-red-600 text-nowrap mt-1/2 ml-1/2">
                                    Please use whole numbers only.
                                </p>
                                <p v-if="employee.emptyAmount" class="text-sm text-red-600 text-nowrap mt-1/2 ml-1/2">
                                    Please enter the amount.
                                </p>
                            </div>
                            <div class="w-60 px-2 text-sm font-normal text-center truncate">
                                <ElementsInput v-model="employee.transactionNote" placeholder="Remark" :maxlength="20" :full="true" />
                            </div>
                            <button @click="clickDeleteButton(index)" class="w-32 px-4 border rounded border-indigo-400 text-indigo-400 py-1.5 text-center">
                                Delete
                            </button>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="w-full p-10">
            <div class="w-full h-[1px] bg-[#D9D9D9] relative">
                <div class="w-[147px] bg-[#fff] absolute text-center left-[50%] translate-x-[-50%] top-[-10px]">
                    Message
                </div>
            </div>
            <textarea
                v-model="transactionMessage"
                placeholder="Message"
                maxlength="150"
                @input="onMessageInput($event.target.value)"
                :class="['p-5 outline-0 w-full h-[114px] text-sm rounded-lg bg-white transition-all duration-500 shadow shadow-gray-100', showTransactionMessageError ? 'border-accent-red-3 border' : 'border']" />
            <p v-if="showTransactionMessageError" class="mt-2 font-inter-caption-2 text-accent-red-3">{{ transactionMessageErrorMessage }}</p>
        </div>
        <div class="w-full p-10">
            <div class="w-full h-[1px] bg-[#D9D9D9] relative">
                <div class="w-[250px] bg-[#fff] absolute text-center left-[50%] translate-x-[-50%] top-[-10px]">Total Amount : {{ numberWithCommas(totalAmount) }} Point</div>
            </div>
            <button @click="clickTransferButton" v-if="isTransfer"
                    class="rounded mt-[50px] w-full text-center h-[62px] leading-[62px] bg-[#4640DE] text-white">
                Transfer
            </button>
            <button @click="clickDeductButton" v-if="isDeduct"
                    class="rounded mt-[50px] w-full text-center h-[62px] leading-[62px] bg-[#4640DE] text-white">
                Deduct
            </button>
        </div>
        <Teleport to="body">
            <designDialogueModal 
                v-model="showFailedListPopup"
                :modalTitle="'Invalid or unregistered email found\nin the template.'"
                :modalContent="'Please check the rows below and try again.'"
                :iconConfig="{label: 'warning', color : 'text-red-400', width: 24, height: 24, weight : 'FILL' }"
                :confirmConfig="{ label : 'Download & Check the error message', type : 'RED', action : 'confirm', variant : 'FILL' }"
                modalWidth="w-[400px]"
                @confirm="getErrorExcelFile"
            >
                <template v-slot:confirm-front-icon>
                    <DownloadIcon :color="'text-invert'" width="16" height="16" />
                </template>
                <template v-slot:modal-content-extra>
                    <div class="font-body-sm-semibold text-accent-red-3">
                        {{ getFailEmailList() }}
                    </div>
                </template>
            </designDialogueModal>
            <designDialogueModal 
                v-model="showEmptyFilePopup"
                :modalTitle="'No email found in the template.'"
                :modalContent="'Please add email addresses to the rows below and try again.'"
                :dialogType="'ALERT'"
                modalWidth="w-[400px]"
                @confirm="()=>{showEmptyFilePopup=false}"
            />
            <DesignConfirmPopup
                v-model="showAlertPopup"
                :showTitle="true"
                title="Failed"
                :confirmDescription="alertPopupMessage"
                buttonText="OK"
                confirmBtnType="RED_SOLID"
                :showCancel="false"
            />
            <DesignConfirmPopup
                v-model="showConfirmPopup"
                :showTitle="true"
                title="Confirm"
                :confirmDescription="confirmMessage"
                buttonText="Yes"
                :showCancel="true"
                cancelText="Cancel"
                :hasAfterConfirm="true"
                @after-confirm="clickSubmit"
            />
        </Teleport>
    </div>
</template>

<script>
import DesignDropdownSelect from '@/components/design-system/design-dropdown-select.vue';
import DesignConfirmPopup from '@/components/design-system/design-confirm-popup.vue';
import designDialogueModal from '@/components/design-system/design-dialogue-modal.vue';
import DownloadIcon from '@/components/design-system/icon/download-icon.vue';
import { FileValidateUtil } from '@/plugins/app-util.js';

export default {
    components: {
        DesignDropdownSelect,
        DesignConfirmPopup,
        designDialogueModal,
        DownloadIcon
    },
    props: {
        transactionType: String,
        taxApplied: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['clickTransferButton', 'clickDeductButton'],
    data() {
        return {
            walletCategoryOptions: [],
            selectedWalletCategorySeq: null,
            selectedWalletCategoryName: null,
            showWalletCategoryError: false,
            walletCategoryErrorMessage: 'Please select a wallet.',

            availableWalletAmount: 0,

            totalAmount: 0,

            transactionMessage: '',
            uploadFile: null,
            inValidFileType: false,
            inValidFileTypeMessage: '',

            excelList: [],
            failedList: [],
            failedExcelPath : "",

            showFailedListPopup: false,
            showAlertPopup: false,
            alertPopupMessage: null,
            showConfirmPopup: false,
            showEmptyFilePopup : false,
            confirmMessage: '',

            showTransactionMessageError: false,
            transactionMessageErrorMessage: 'Please provide a message to display.',

            scrollYBackup: 0,
            hasRunValidation: false,
        };
    },
    computed: {
        // 여기에 모달이 더 있으면 || 로 추가
        isAnyPopupOpen() {
            return this.showFailedListPopup || this.showAlertPopup || this.showConfirmPopup || this.showEmptyFilePopup;
        },
        isTransfer() { return this.transactionType === 'transfer'; },
        isDeduct() { return this.transactionType === 'deduct'; },
    },
    watch: {
        isAnyPopupOpen(val) {
            if (val) {
                this.lockBodyScroll();
            } else {
                this.unlockBodyScroll();
            }
        },
    },
    mounted() {
        const self = this;
        self.getWalletCategoryList();
        self.getAvailablePoint();
    },
    methods: {
        initValidationErrors() {
            this.showTransactionMessageError = false;
            this.showWalletCategoryError = false;
        },
        lockBodyScroll() {
            // 현재 스크롤 위치 저장
            this.scrollYBackup = window.scrollY || document.documentElement.scrollTop || 0;

            // 레이아웃 점프 방지 및 스크롤 잠금
            document.body.style.position = 'fixed';
            document.body.style.top = `-${this.scrollYBackup}px`;
            document.body.style.left = '0';
            document.body.style.right = '0';
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden'; // 보조(데스크톱)
        },
        unlockBodyScroll() {
            // 원복
            const y = this.scrollYBackup || 0;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.left = '';
            document.body.style.right = '';
            document.body.style.width = '';
            document.body.style.overflow = '';

            // 저장해 둔 위치로 복귀
            window.scrollTo(0, y);
        },
        getWalletCategoryList() {
            const self = this;
            const url = self.$api('uri', 'get-wallet-category-list');
            self.$axios
                .get(url)
                .then((res) => {
                    self.walletCategoryOptions = res.data.data.list.map((wallet) => ({
                        text: wallet.walletCategoryName,
                        value: wallet.walletCategorySeq,
                    }));
                })
                .catch((err) => {
                    console.error('err : ', err);
                });
        },
        convertCommaStringToNumber(value) {
            if (value == null || value === '') {
                return '';
            }
            return Number(String(value).replaceAll(',', ''));
        },
        convertNumberToCommaString(value) {
            let decimalValue = String(value);
            decimalValue = decimalValue.replace(/(\..*)\./g, '$1'); // 첫 번째 소수점 이후에 나오는 추가 소수점을 제거

            const parts = decimalValue.split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return parts.join('.');
        },
        numberWithCommas(number) {
            if (number == null || Number.isNaN(Number(number))) {
                return number;
            }

            return this.convertNumberToCommaString(number);
        },
        getAvailablePoint() {
            const self = this;

            const url = self.$api('uri', 'get-availablePoint');
            self.$axios
                .get(url)
                .then((res) => {
                    self.availableWalletAmount = res.data.data.availableWalletAmount;
                })
                .catch((err) => {
                    console.error('err : ', err);
                });
        },
        clickDeleteButton(index) {
            const self = this;

            self.excelList.splice(index, 1);

            self.calTotalAmount();
        },
        clickTransferButton() {
            const self = this;
            if (self.checkValidation() != 0) {
                return;
            }

            // total amount 가 가지고 있는 것보다 큰 경우 (transfer 인 경우에만 적용)
            if (self.totalAmount > self.availableWalletAmount) {
                self.openAlertPopup('The amount of transfer is more than total');
                return;
            }

            self.openConfirmPopup('Are you sure you want to transfer points?');
        },
        clickDeductButton() {
            const self = this;

            if (self.checkValidation() != 0) {
                return;
            }

            self.openConfirmPopup('Are you sure you want to deduct points?');
        },
        onInputMileage(event, employee) {
            const input = event.target.value;
            const mileage = input.replace(/[^0-9]/g, '');

            if (mileage==null || mileage=='' || mileage==0) {
                employee.emptyAmount = true;
            } else {
                employee.emptyAmount = false;
            }

            let result = this.convertCommaStringToNumber(mileage);
            employee.mileageVolume = result;
            employee.mileageVolumeFormat = this.numberWithCommas(result);
            this.calTotalAmount();

            if ( Number.isInteger(Number(result)) ) {
                employee.isNotInteger = false;
            } else {
                employee.isNotInteger = true;
            }
        },
        calTotalAmount() {
            const self = this;
            self.totalAmount = 0;
            if (self.excelList.length == 0) return;

            self.excelList.map((employee) => {
                if( !employee.mileageVolume ) return;
                const points = Number(employee.mileageVolume);

                self.totalAmount += points;
            });
        },
        checkValidation() {
            this.hasRunValidation = true;
            this.initValidationErrors();

            if ((this.transactionMessage || '').trim().length === 0) {
                this.showTransactionMessageError = true;
            }

            if (!this.selectedWalletCategorySeq) {
                this.showWalletCategoryError = true;
            }

            if (this.isTransfer && (this.showTransactionMessageError || this.showWalletCategoryError)) {
                this.openAlertPopup('Transfer failed due to an invalid input. Please check and try again.');
                return 1;
            }

            // 세금 적용 시, 각 직원별 전송 포인트가 최소 2 이상인지 확인
            if (this.isTransfer && this.taxApplied) {
                const forms = Array.isArray(this.excelList)
                    ? this.excelList
                    : [];

                const hasBelowMinimum = forms.some((form) => {
                    const amount = Number(form.mileageVolume || 0);
                    return Number.isNaN(amount) || amount < 2;
                });

                if (hasBelowMinimum) {
                    this.openAlertPopup('Please enter at least 2 points for each employee.');
                    return 1;
                }
            }


            if (this.isDeduct && (this.showTransactionMessageError || this.showWalletCategoryError)) {
                this.openAlertPopup('Deduct failed due to an invalid input. Please check and try again.');
                return 1;
            }

            //validation ---------------------------------------------------------------------------------
            //중복 값 제거
            let validationCnt = 0;
            this.excelList = this.excelList.filter((character, idx) => {
                if (character.email == null || '') return;
                return this.excelList.findIndex((item) => item.email == character.email) === idx;
            });

            //mileageVolume 에 정수 외의 값을 입력했을 경우
            this.excelList.map((employee) => {
                const points = Number(employee.mileageVolume);
                if( Number.isNaN(points)
                    || points < 1
                    || !Number.isInteger(points) ){
                    validationCnt++;
                }
            });

            if (validationCnt > 0) {
                this.openAlertPopup('You need to enter the point amount.');
                return validationCnt;
            }

            //아무도 선택하지 않았을 경우
            if (this.excelList.length == 0) {
                this.openAlertPopup('Please upload the excel template file.');
                validationCnt++;
            }

            if (validationCnt > 0) return validationCnt;

            this.calTotalAmount();
            return validationCnt;
        },
        clickUploadButton(event) {
            const self = this;
            event.preventDefault();

            self.inValidFileType = false;
            self.inValidFileTypeMessage = '';

            if (self.uploadFile == null) {
                this.openAlertPopup('Please upload a file.');
                return;
            }

            if (FileValidateUtil.isXlsFile(self.uploadFile)) {
                self.inValidFileType = true;
                self.inValidFileTypeMessage = FileValidateUtil.errMsg.xls;
                return;
            }
            if (!FileValidateUtil.isXlsxFile(self.uploadFile)) {
                self.inValidFileType = true;
                self.inValidFileTypeMessage = FileValidateUtil.errMsg.xlsxOnly;
                return;
            }

            const formProps = new FormData(self.$refs['fileUploadForm']);
            formProps.append('isTransfer', self.isTransfer);
            const url = self.$api('uri', 'post-transaction-execute-file');

            self.$axios
                .post(url, formProps, {
                    headers: {
                        'Content-Type': 'multipart/form-data;',
                    },
                })
                .then((res) => {
                    self.failedList = res.data.data.failedList;
                    self.failedExcelPath = res.data.data.failedPath;
                    if (self.failedList.length > 0) {
                        self.showFailedListPopup = true;
                        return;
                    }

                    if(res.data.data.excelList.length == 0 ){
                        self.showEmptyFilePopup = true;
                        return;
                    }

                    self.excelList = res.data.data.excelList;

                    self.excelList?.forEach((employee) => {
                        // 순서 변경할 경우 누락 가능성
                        if (employee.transactionNote != null) {
                            employee.transactionNote = employee.transactionNote.substring(0, 20);
                        }
                        
                        employee.isNotInteger = false;
                        employee.emptyAmount = false;   
                        
                        const originMileage = employee.mileageVolume;
                        const mileageNum = Number(originMileage);
                        
                        const isInvalidNum = !originMileage || Number.isNaN(mileageNum) || mileageNum==0;
                        if(isInvalidNum){
                            employee.emptyAmount = true;
                            employee.mileageVolume = null;
                            employee.mileageVolumeFormat = null;
                            return;
                        }
                
                        // 소수 기입 시, 알림 발생
                        employee.isNotInteger = !Number.isInteger(mileageNum);
                        employee.mileageVolume = this.convertCommaStringToNumber(originMileage);
                        employee.mileageVolumeFormat = this.numberWithCommas(originMileage);
                    });
                    
                    self.calTotalAmount();
                })
                .catch((err) => {
                    const errCode = err?.response?.data?.code;
                    if (errCode == FileValidateUtil.notSupported) {
                        self.inValidFileType = true;
                        self.inValidFileTypeMessage = FileValidateUtil.errMsg.xlsxOnly;
                        return;
                    }
                    if (errCode == FileValidateUtil.strictOOXML) {
                        self.inValidFileType = true;
                        self.inValidFileTypeMessage = FileValidateUtil.errMsg.strictXlsx;
                        return;
                    }

                    this.openAlertPopup('Please upload the excel template file.');

                    console.error('err : ', err);
                });
        },
        removeFile() {
            const self = this;
            self.uploadFile = null;
            self.inValidFileType = false;
            self.inValidFileTypeMessage = '';
        },
        getFailEmailList() {
            if (this.failedList == null || this.failedList.length == 0) {
                return '';
            }

            let emailList = [];
            for (let i = 0; i < this.failedList.length; ++i) {
                emailList.push(this.failedList[i].rowIndex);
            }

            return '*Rows: ' + emailList.join(', ');
        },
        openConfirmPopup(message) {
            this.confirmMessage = message;
            this.showConfirmPopup = true;
        },
        hideConfirmPopup() {
            this.showConfirmPopup = false;
        },
        resetState() {
            // clear validation/errors
            this.initValidationErrors();
            // clear file mode data
            this.excelList = [];
            this.transactionMessage = '';
            this.totalAmount = 0;
            this.uploadFile = null;
            this.failedList = [];
            this.failedExcelPath = '';
            this.showFailedListPopup = false;
            this.hasRunValidation = false;
            // reset wallet selection
            this.selectedWalletCategorySeq = null;
            this.selectedWalletCategoryName = null;
            // refresh available points
            this.getAvailablePoint();
        },
        clickSubmit() {
            this.hideConfirmPopup();

            if (this.isTransfer) {
                const employeeTransactionForms = this.excelList.map((emp) => ({
                    companySeq: emp.companySeq,
                    employeeSeq: emp.employeeSeq,
                    employeeName: emp.employeeName,
                    mileageVolume: String(emp.mileageVolume || 0),
                    transactionNote: (emp.transactionNote || '').trim(),
                    employeeEmail: emp.email,
                }));

                const transferForm = {
                    employeeTransactionForms,
                    walletCategorySeq: this.selectedWalletCategorySeq,
                    walletCategoryName: (this.walletCategoryOptions || []).find(o => o?.value === this.selectedWalletCategorySeq)?.text || '',
                    transactionNote: (this.transactionMessage || '').trim(),
                    totalPersonCount: this.excelList.length,
                    totalMileageVolume: this.totalAmount,
                    taxAppliedYN: this.taxApplied? 'Y' : 'N',
                };

                this.$emit('clickTransferButton', transferForm);
            } else if (this.isDeduct) {
                const employeeTransactionForms = this.excelList.map((emp) => ({
                    companySeq: emp.companySeq,
                    employeeSeq: emp.employeeSeq,
                    employeeName: emp.employeeName,
                    mileageVolume: String(emp.mileageVolume || 0),  
                    transactionNote: (emp.transactionNote || '').trim(),
                    employeeEmail: emp.email,
                }));

                const deductForm = {
                    employeeTransactionForms,
                    walletCategorySeq: this.selectedWalletCategorySeq,
                    walletCategoryName: (this.walletCategoryOptions || []).find(o => o?.value === this.selectedWalletCategorySeq)?.text || '',
                    transactionNote: (this.transactionMessage || '').trim(),
                    totalPersonCount: this.excelList.length,
                    totalMileageVolume: this.totalAmount,
                };

                this.$emit('clickDeductButton', deductForm);
            }
        },
        openAlertPopup(message) {
            this.alertPopupMessage = message;
            this.showAlertPopup = true;
        },
        getErrorExcelFile(){
            const self = this;
            //코드 수정 내역이 없어서 새로 controller를 만들지 않음 
            const url = self.$api('uri', 'get-invite-bulk-error');
            const json_query = JSON.stringify({
                excelFilePath: self.failedExcelPath,
            });

            const a = document.createElement('a');
            a.href =  url + `?${encodeURIComponent('json_query')}=${encodeURIComponent(json_query)}`;
            document.body.appendChild(a); 
            a.click();

            document.body.removeChild(a);
            self.showFailedListPopup = false;
            return;
        },
        onChangeWalletCategory() {
            // validation을 한번도 실행하지 않은 경우에는 WalletCategory 필수선택 오류 메세지 보여지지 않도록 함
            if (!this.hasRunValidation) {
                return;
            }
            this.showWalletCategoryError = !this.selectedWalletCategorySeq? true : false;
        },
        onMessageInput(val) {
            // validation을 한번도 실행하지 않은 경우에는 Message 필수입력 오류 메세지 보여지지 않도록 함
            if (!this.hasRunValidation) {
                return;
            }
            this.showTransactionMessageError = !String(val).trim();
        },
    },
};
</script>
